export const apiErrorHandler = (
  error,
  from,
  isRedirectToOopsFromService = false,
  redirectPath
) => {
  if (window.newrelic) {
    window.newrelic.noticeError(error, {errorOrigin: from});
    isRedirectToOopsFromService && (window.location.href = redirectPath);
  }
};
